// @flow
import type {
  BaseCardsType,
  BlokComponentPropsType,
  BlokComponentType,
  TestimonialType
} from 'components/types';
import renderComponent from 'components/editable/renderComponent';
import { interpolate } from 'react-spring/web.cjs';
import Template from '../Template';
import Carousel from '../Carousel';
import { TestimonialCard, TestimonialGrid } from './static';
import { AnimatedTestimonialCard, CARD_DISPLAYS } from './carousel';
import * as componentKeys from '../../../../componentKeys';

const componentMap = {
  [componentKeys.TESTIMONIAL_BLOCK]: TestimonialCard
};

const renderComponentCustomPath =
  'components/editable/Cards/TestimonialCards/index.jsx';
function springsRenderer(
  springs: *[],
  cards: BlokComponentType<TestimonialType>[]
): any {
  return springs.map((styles, index) =>
    renderComponent(
      cards[index],
      {
        key: cards[index]._uid + index,
        customPath: renderComponentCustomPath,
        style: {
          ...styles,
          transform: interpolate(
            [styles.translateX, styles.opacity],
            (translateXVal) => `translate(${translateXVal}px, -50%)`
          )
        },
        component: AnimatedTestimonialCard,
        onDragStart: (event) => {
          // This prevents the default "drag" effect of links in Safari
          event.preventDefault();
          return false;
        }
      },
      componentMap
    )
  );
}

const TestimonialCards = ({
  blok
}: BlokComponentPropsType<{
  ...BaseCardsType,
  cards: BlokComponentType<TestimonialType>[]
}>) => {
  const {
    title,
    sub_title: subTitle,
    description,
    cards,
    call_to_action: callToAction,
    call_to_action_text: callToActionText,
    use_carousel: useCarousel
  } = blok;
  let children;
  if (useCarousel) {
    children = (
      <Carousel
        cards={cards}
        title={title}
        cardDisplays={CARD_DISPLAYS}
        springsRenderer={springsRenderer}
      />
    );
  } else {
    children = (
      <TestimonialGrid>
        {cards.map((card, index) =>
          renderComponent(
            card,
            {
              customPath: renderComponentCustomPath,
              key: card._uid + index,
              totalCards: cards.length
            },
            componentMap
          )
        )}
      </TestimonialGrid>
    );
  }
  return (
    <Template
      callToAction={callToAction}
      callToActionText={callToActionText}
      description={description}
      subTitle={subTitle}
      title={title}
      useCarousel={useCarousel}
    >
      {children}
    </Template>
  );
};

export default TestimonialCards;
